import React, { useState, useEffect } from 'react';
import { BobbyCalvesNvd, CattleNvd, SheepNvd, GoatsNvd } from './forms';
import { ENVDWrapper, LoadingWrapper, BackButton } from './style';

const ENVDForm = () => {
  const [formType, setFormType] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const handleBack = () => {
    window.history.back();
  };

  useEffect(() => {
    const getQueryParams = () => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('formType');
    };
    const urlFormType = getQueryParams();
    setFormType(urlFormType || 'cattle');
    setIsLoading(false);
    const handlePopState = () => {
      const newFormType = getQueryParams();
      setFormType(newFormType || 'cattle');
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  // Render the appropriate form based on formType
  const renderForm = () => {
    switch (formType.toLowerCase()) {
      case 'cattle':
        return <CattleNvd />;
      case 'sheep':
        return <SheepNvd />;
      case 'bobbycalves':
      case 'bobby-calves':
      case 'calves':
        return <BobbyCalvesNvd />;
      case 'goats':
        return <GoatsNvd />;
      default:
        return <CattleNvd />;
    }
  };

  if (isLoading) {
    return (
      <ENVDWrapper>
        <LoadingWrapper>Loading form...</LoadingWrapper>
      </ENVDWrapper>
    );
  }

  return (
    <ENVDWrapper>
      {' '}
      <BackButton type="button" onClick={handleBack} style={{ maxWidth: 'fit-content' }}>
        ← Back
      </BackButton>
      <div className="form-content">{renderForm()}</div>
    </ENVDWrapper>
  );
};

export default ENVDForm;
